export default {
    "graphqlEndpoint": "https://lpqrpptrtrfuvplt62yjamq7ne.appsync-api.eu-west-1.amazonaws.com/graphql",
    "region": "eu-west-1",
    "authType": "API_KEY",
    "apiKey": "da2-kxke35sdrfcwjlrpjpbokouyzq"
  }